import React from 'react';
import playstoreSvg from '../assets/playstore_icon.svg';

export default function PlayStoreIcon({ className = 'h-11 w-auto' }) {
  return (
    <img
      src={playstoreSvg}
      alt="Get it on Google Play"
      className={`object-contain transition-transform duration-300 hover:scale-105 ${className}`}
    />
  );
}
